// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Wj-z","centerLink":"Xj-z","productSection":"Yj-z","item":"Zj-z","ctaButton":"_j-z"};